import { createFileRoute } from '@tanstack/react-router';
import { getEPADetailsQuery } from '@/app/hooks/queries/useEarlyPhaseAssessment';
import { useSuspenseQuery } from '@tanstack/react-query';
import EvaluationActivityLog from '@/app/components/features/evaluations/EvaluationActivityLog';
import { EvaluationTypeLabelsEnum } from '@/app/utils/constants';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/early-phase-assessments/$earlyPhaseAssessmentId/_layout/(home)/activity',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { earlyPhaseAssessmentId } = Route.useParams();
  const { data: earlyPhaseAssessment } = useSuspenseQuery(
    getEPADetailsQuery(earlyPhaseAssessmentId),
  );

  return (
    <EvaluationActivityLog
      resourceName={earlyPhaseAssessment.name}
      evaluationId={earlyPhaseAssessmentId}
      resourceType={EvaluationTypeLabelsEnum.EARLY_PHASE_ASSESSMENT}
      resourceCreatedAt={earlyPhaseAssessment.createdAt}
    />
  );
}
